import { reactive } from "@vue/composition-api";
import axios from "axios";
import router from "@/router";

export default function companyCheckAmountStore() {
  type state = {};
  const state = reactive({
    loading: false,
    amountInfor: {
      menu: false,
      month: '',
      agreementDate: new Date().toISOString().substr(0, 7),
      settlementButton: true,
      matchingCount: '',
      matchingFlag: false,
      numberCompletePayment: '',
      advertisingFee: '',
      evaluationCompanyName: '',
      advanceCost: '',
      headers: [
        { text: "求人名", value: "business_name", align: 'center' },
        { text: "ユーザー名", value: "cyurica_num", align: 'center' },
        { text: "決済日", value: "adoption_date", align: 'center' },
        { text: "支払区分", value: "code_desc", align: 'center', sortable: false },
        { text: "決済額", value: "settlement_amount", align: 'center', sortable: false },
        { text: "源泉徴収額", value: "payroll_tax", align: 'center', sortable: false },
      ],
      values: [] as any,
      paymentPreview: [] as any,
      jobPayment: [] as any
    }
  })

  //function export to file csv
  const exportToCsv = (filename: any, rows: any) => {
    let processRow = function (row: any) {
      let finalVal = '';
      for (let j = 0; j < row.length; j++) {
        let innerValue = row[j] === null ? '' : row[j].toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        };
        let result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0)
          result = '"' + result + '"';
        if (j > 0)
          finalVal += ',';
        finalVal += result;
      }
      return finalVal + '\n';
    };

    let csvFile = '';
    for (let i = 0; i < rows.length; i++) {
      csvFile += processRow(rows[i]);
    }

    let blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      let link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  const axiosinstance = axios.create({
    baseURL: process.env.VUE_APP_API_SERVER
  });
  //axiosinstance.defaults.timeout = 3500;
  axiosinstance.interceptors.response.use(
    // 2XX範囲内のステータスコード
    (response) => {
      return response;
    },
    // 2XX範囲外のステータスコード
    (error) => {
      var response = error.response
      if(response && (response.status == 401 || response.status == 500)){
        localStorage.clear()
        router.push("/");
      }
      return Promise.reject(error);
    }
  );
  return {
    get amountInfor() {
      return state.amountInfor
    },
    get loading() {
      return state.loading
    },

    inputMonth(e:string) {
      state.amountInfor.month = e
    },

    paymentPreview(date: any) {
      const left = (screen.width / 2) - (500);
      const top = (screen.height / 2) - (300);
      return window.open(`/company_payment/settlement_preview/month/${date}`, '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=1000px, height=600px, top=' + top + ', left=' + left);
    },

    print() {
      window.print()
    },

    setMonthValue(month: any) {
      state.amountInfor.month = month
    },

    resetTableValue() {
      state.amountInfor.values = []
      state.amountInfor.paymentPreview = []
      state.amountInfor.agreementDate = new Date().toISOString().substr(0, 7)
    },
    async getPaymentInfor(date: any) {
      await axiosinstance
        .get(
          "company/v0/settlement?year_month=" + date,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token"),
            }
          }
        )
        .then(response => {
          state.amountInfor.paymentPreview = response.data.map((item: { adoption_date: string }) => {
            let date = item.adoption_date.substring(0, item.adoption_date.indexOf("T"));
            item.adoption_date = date;
            return item;
          })
        });

      await axiosinstance
        .get(
          "company/v0/totalReferral?year_month=" + date,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token"),
            }
          }
        )
        .then(response => {
          state.amountInfor.advanceCost = response.data.total_referral
        })
        .then(() => {
        });

      await axiosinstance
        .get(
          "company/v0/totalPayment?year_month=" + date,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token"),
            }
          }
        )
        .then(response => {
          state.amountInfor.advertisingFee = response.data.total_payment
        })
        .then(() => {
        });
    },

    getSettlementInfor(date: any) {
      state.amountInfor.values = []
      axiosinstance
        .get(
          `company/v0/settlement?year_month=${date}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token"),
            }
          }
        )
        .then(response => {
          state.amountInfor.values = response.data
          state.amountInfor.values.map((items: any) => {
            if (items.adoption_date){ 
              items.adoption_date = items.adoption_date.slice(0, 10).replace(/(\d{4})-(\d{2})-(\d{2})/g, '$1/$2/$3') 
            } else {
              items.adoption_date= ''
            }
            state.amountInfor.evaluationCompanyName = items.company_name
            if (items.code !== '006001') {
              items.payroll_tax = ''
            } else if (items.tax_deduct === 0) {
              items.payroll_tax = '-'
            }
          })
        })
        .then(() => {
        });

      //get matching count
      axiosinstance
        .get(
          `company/v0/matchingCount?year_month=${date}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token"),
            }
          }
        )
        .then(response => {
          state.amountInfor.matchingCount = response.data.matching
        })
        .then(() => {
        });

      //get financial count
      axiosinstance
        .get(
          `company/v0/financialCount?year_month=${date}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token"),
            }
          }
        )
        .then(response => {
          state.amountInfor.numberCompletePayment = response.data.financial
        })
        .then(() => {
        });

      axiosinstance
        .get(
          `company/v0/totalPayment?year_month=${date}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token"),
            }
          }
        )
        .then(response => {
          if (!response.data.total_payment) response.data.total_payment = 0
          state.amountInfor.advertisingFee = response.data.total_payment + ' 円'
        })
        .then(() => {
        });

      axiosinstance
        .get(
          `company/v0/totalReferral?year_month=${date}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token"),
            }
          }
        )
        .then(response => {
          if (!response.data.total_referral) response.data.total_referral = 0
          state.amountInfor.advanceCost = response.data.total_referral + ' 円'
        })
        .then(() => {
          state.loading = false
        });
    },
    

    getUserSettlement(date: any) {
      axiosinstance
        .get(
          `company/v0/userSettlement?year_month=${date}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token"),
            }
          }
        )
        .then(response => {
          let csvFile = [
            ['求人名', 'ジョブペイ・キュリカ番号', '氏名', '勤務日', '立替費(円)'],
          ]
          response.data.map((item: any) => {
            csvFile.push([`'${item.business_name}`, `'${item.cyurica_num}`, `${item.user_name}`, `'${item.work_start_date.replace(/-/g, '/')}`, `${item.total_daily_amt}`])
          })
          exportToCsv(`user_payment_infor_${date.split('-').join('')}.csv`, csvFile)
        })
        .then(() => {
        });
    },

    getJobSettlement(date: any) {
      axiosinstance
        .get(
          `company/v0/jobSettlement?year_month=${date}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token"),
            }
          }
        )
        .then(response => {
          state.amountInfor.jobPayment = response.data
        })
        .then(() => {
        });
    }

  }
}

export type CompanyCheckAmountStore = ReturnType<typeof companyCheckAmountStore>;
